/** True when the app runs as an installed PWA (or iOS standalone). */
export function isStandaloneDisplayMode(): boolean {
  if (typeof window === 'undefined') return false;
  const mm = window.matchMedia?.('(display-mode: standalone)');
  if (mm?.matches) return true;
  return (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
}

/** Viewport considered “mobile” for hub redirect and install banner (< 768px). */
export function isMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(max-width: 767px)').matches;
}

/** Post-login hub: standalone PWA or narrow browser. */
export function shouldUseMobileHub(): boolean {
  return isStandaloneDisplayMode() || isMobileViewport();
}

/** Install hints: mobile viewport only, not already standalone. */
export function shouldOfferPwaInstallUi(): boolean {
  if (typeof window === 'undefined') return false;
  if (!isMobileViewport()) return false;
  if (isStandaloneDisplayMode()) return false;
  return true;
}

/** iPhone / iPad (any browser: Safari, Chrome iOS, etc.) — share → Add to Home is the install path. */
export function isIosDevice(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent;
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

/** Safari on iOS (excludes Chrome/Firefox/Edge on iOS). Kept for analytics or future use. */
export function isIosSafari(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent;
  const iOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const webkit = /WebKit/.test(ua);
  const noChrome = !/CriOS|FxiOS|EdgiOS/.test(ua);
  return iOS && webkit && noChrome;
}
